module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Layers":"Kartenebenen"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./app/components/layerlist/ToggleButton.vue
// module id = 3REv
// module chunks = 1